import { chatChipNonVisblePages, conflictingPageMapping, inlineButtonChatPages } from '../../context/page-mapping';
import { t } from '../app-utils/translations';
import { isHelpCenterHomepage, isOrderHelpPage } from '../app-utils/page-specific-utils';

export const getButtonConfig = (): { enableChat: boolean; buttonType?: 'inline' | 'floating' | 'hybrid' } => {
  const pageURL = window.location.href;
  if (chatChipNonVisblePages.find((ele) => pageURL.includes(t(ele)))) {
    return { enableChat: false };
  }
  if (isHelpCenterHomepage()) {
    return { buttonType: 'hybrid', enableChat: true };
  }
  if (isOrderHelpPage()) {
    return { buttonType: 'inline', enableChat: true };
  }
  if (inlineButtonChatPages.find((ele) => pageURL.includes(t(ele)))) {
    return { buttonType: 'inline', enableChat: true };
  }
  return { enableChat: true, buttonType: 'floating' };
};

export const addConflictingPageCSSClass = (buttonElement, conflictingPageName, cssClass) => {
  if (window.location.href.includes(t(conflictingPageName))) {
    (buttonElement as HTMLButtonElement).classList.add(cssClass);
  }
};

export const isPageConflicting = () => {
  const pageUrl = window.location.href;
  return !!conflictingPageMapping.find((ele) => pageUrl.includes(t(ele.pageName)));
};

export const getMetaContentByName = (name: string): string | null => {
  const metaTag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  return metaTag?.content || null;
};
